import { BaseParams, NodeData } from './base';
import { type ContextItemData, type SkillItemData } from './types';

export interface CreateSkillContextParams extends BaseParams {
  skillId: string;
  skillName: string;
}

export class SkillNodeData extends NodeData {
  public skillId: string;
  public skillName: string;

  constructor(params: CreateSkillContextParams) {
    super({
      ...params,
      id: params.skillId,
      type: 'skill',
      text: params.skillName,
    });
    this.skillId = params.skillId;
    this.skillName = params.skillName;
    this.text = params.skillName;
  }

  formatForLLM(codeElementIds?: string[]): ContextItemData {
    return {
      type: this.type,
      codeElementIds,
      bypassLimits: this.bypassLimits,
      data: {
        name: this.skillName,
        skillId: this.skillId,
        skillName: this.skillName,
        text: this.text,
      } satisfies SkillItemData,
    };
  }
}
